import { IProductRequest } from "../../Interfaces/IProductRequest"

const normalizeSearchValue = (value: string): string => {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
}

const formatPriceForSearch = (value: number): string[] => {
  if (Number.isNaN(value)) {
    return []
  }

  const formattedCurrency = value.toMoney()

  const normalizedCurrency = formattedCurrency
    .replace("R$", "")
    .replace(/\s/g, "")

  return [
    formattedCurrency,
    normalizedCurrency,
    value.toDecimalString(),
    value.toString(),
    value.toLocaleString("pt-BR"),
  ]
}

export const filterMenuProductsByQuery = (products: IProductRequest[], query: string): IProductRequest[] => {
  const normalizedQuery = normalizeSearchValue(query)

  if (!normalizedQuery) {
    return products
  }

  return products.filter((product) => {
    const searchableFields = [
      product.name,
      product.description,
      ...(product.comboItemsPreview ?? []),
      product.categoryIcon,
      ...formatPriceForSearch(product.price),
      ...formatPriceForSearch(product.oldPrice ?? Number.NaN),
    ]

    return searchableFields.some((field) => normalizeSearchValue(String(field ?? "")).includes(normalizedQuery))
  })
}
